import React from "react";

export default function LoadingSpinner({ size = 24, color = "#C62828" }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      style={{ animation: "spin 0.8s linear infinite" }}
      className="inline-block"
    >
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <circle cx="12" cy="12" r="10" fill="none" stroke="#F5F5F5" strokeWidth="3" />
      <path d="M12 2a10 10 0 0110 10" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function PageLoader() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3">
      <LoadingSpinner size={40} />
      <p className="text-sm text-gray-400 font-medium">Memuat data...</p>
    </div>
  );
}
